/**
 * 官網等內網系統以 window.open + postMessage 呼叫 MyBro，自動帶入問題並送出（AGUI-1161-2）。
 * 握手協定與官網約定：B 端（本檔）必須先 addEventListener 才能送 READY，否則 A 端收到 READY 後
 * 送出的訊息會無人接收；READY/ACK 值刻意改為亂數而非常見字串，避免跟其他來源（瀏覽器套件、
 * 開發工具、內嵌 iframe 皆會對 window 送 message 事件）的訊息撞名。
 *
 * 內容只在記憶體與 sessionStorage 之間傳遞，不進 URL、不進 log；收到後只負責暫存，
 * 由 App.js 在登入完成＋聊天歷史載入完成後接手消費（不在此檔案內直接送出訊息）。
 */
import logger from './logger';

const READY_SIGNAL = 'gsAJPFBpeEDNr2wWG83UX74a';
const ACK_SIGNAL = 'mBmra6m738A5zKeuXbbUU8F3';
const MESSAGE_TYPE = 'PORTAL_SEARCH';

export const OFFICIAL_SITE_PENDING_PROMPT_KEY = 'mybro_pending_official_site_prompt';

const targetOrigin = process.env.REACT_APP_OFFICIAL_SITE_ORIGIN || '';

function handleMessage(event) {
  // 來源驗證：origin 與 event.source 都要對得上，非約定來源一律忽略、不回應
  if (event.origin !== targetOrigin) return;
  if (event.source !== window.opener) return;

  const data = event.data;
  if (!data || data.type !== MESSAGE_TYPE) return;

  const prompt = typeof data.payload === 'string' ? data.payload.trim() : '';
  if (!prompt) return;

  try {
    window.sessionStorage.setItem(OFFICIAL_SITE_PENDING_PROMPT_KEY, prompt);
  } catch (error) {
    logger.warn('AUTH', '暫存官網帶入問題失敗', { error: error?.message });
    return;
  }

  logger.auth('已收到官網帶入的問題，回覆 ACK');
  window.opener?.postMessage(ACK_SIGNAL, targetOrigin);
}

/**
 * 供 index.js 在 React 掛載前呼叫。未設定 REACT_APP_OFFICIAL_SITE_ORIGIN（例如 prod
 * 尚未串接官網正式網域）時整段跳過，等同功能關閉；沒有 window.opener（非由其他視窗開出，
 * 或 opener 被 Cross-Origin-Opener-Policy 切斷）時只掛監聽、不送 READY。
 */
export function initOfficialSiteBridge() {
  if (!targetOrigin) return;

  // 必須先掛監聽再送 READY，否則官網收到 READY 後立刻送出的訊息會無人接收
  window.addEventListener('message', handleMessage);

  if (!window.opener) {
    return;
  }

  window.opener.postMessage(READY_SIGNAL, targetOrigin);
}
